import { render, staticRenderFns } from "./AddEmployeesPullout.vue?vue&type=template&id=485a2227&scoped=true&"
import script from "./AddEmployeesPullout.vue?vue&type=script&lang=js&"
export * from "./AddEmployeesPullout.vue?vue&type=script&lang=js&"
import style0 from "./AddEmployeesPullout.vue?vue&type=style&index=0&id=485a2227&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485a2227",
  null
  
)

export default component.exports